import { SVGProps, Ref, forwardRef } from 'react';

export const HhSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M6.574 6.805c.368 0 .669.123.88.347.21.221.322.545.322.943v2.341h-1.06V8.31c0-.204-.05-.35-.135-.446a.48.48 0 0 0-.364-.143.55.55 0 0 0-.454.208c-.119.15-.198.405-.198.803v1.709h-1.06V5.58h1.06v1.773c.202-.357.552-.548 1.01-.548m4.078 0c.367 0 .668.123.88.347.209.221.321.545.321.943v2.341h-1.059V8.31c0-.204-.05-.35-.136-.446a.48.48 0 0 0-.364-.143.55.55 0 0 0-.453.208c-.12.15-.199.405-.199.803v1.709H8.583V5.58h1.06v1.773c.201-.357.552-.548 1.009-.548"
            fill="currentColor"
        />
    </svg>
));
HhSolidSize16Glyph.displayName = 'HhSolidSize16Glyph';
